var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-success"},[_vm._m(0),_c('h3',{staticClass:"ws-success-title"},[_vm._v(_vm._s(_vm.$t('wizard.success_title')))]),_c('p',{staticClass:"ws-success-desc"},[_vm._v(_vm._s(_vm.$t('wizard.success_desc')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-success-icon"},[_c('i',{staticClass:"fal fa-check"})])
}]

export { render, staticRenderFns }